import {API} from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";



export const getPayment = (userId, token, paymentId) => {
    return fetch(`${API}/payment/${userId}/${paymentId}`,{
        method: "GET",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
      },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getAllPayments=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/payments/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const getPaymentCount=(userId,token,query)=>{
    let str=objectToQueryString(query);
    return fetch(`${API}/payments/count/${userId}?${str}`,{
        method:'GET',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const changeInvoiceDate=(userId,token,paymentId,body)=>{
    return fetch(`${API}/payment/change-invoice/${userId}/${paymentId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            'Content-Type':"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const changeBalanceDueDate=(userId,token,paymentId,body)=>{
    return fetch(`${API}/payment/change-balance-due-date/${userId}/${paymentId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            'Content-Type':"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};
export const changePaymentDate=(userId,token,paymentId,body)=>{
    return fetch(`${API}/payment/change-payment-date/${userId}/${paymentId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            'Content-Type':"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify(body)
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const sendInvoiceToWhatsapp=(userId,token,paymentId)=>{
    return fetch(`${API}/send-invoice-to-whstapp/${userId}/${paymentId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const getPaymentByMembershipId=(userId,token,membershipId) => {
    return fetch(`${API}/payment/membership/${userId}/${membershipId}`,{
        method:"GET",
        headers: {
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json()
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getPaymentByMembershipIDs=(userId,token,membershipIds)=>{
    return fetch(`${API}/payment/memberships/${userId}`,{
        method:'POST',
        headers:{
            Accept:"application/json",
            'Content-Type':"application/json",
            Authorization:`Bearer ${token}`
        },
        body:JSON.stringify({ membershipIds })
    }).then(response=>{
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


